import { render, staticRenderFns } from "./tiaoman.vue?vue&type=template&id=74b5f07c&scoped=true&"
import script from "./tiaoman.vue?vue&type=script&lang=js&"
export * from "./tiaoman.vue?vue&type=script&lang=js&"
import style0 from "./tiaoman.vue?vue&type=style&index=0&id=74b5f07c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b5f07c",
  null
  
)

export default component.exports